import { render, staticRenderFns } from "./accordion_item.vue?vue&type=template&id=72a90275"
import script from "./accordion_item.vue?vue&type=script&lang=js"
export * from "./accordion_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports